import { useTranslation } from '@shared/core';
import { Box, Flex, TextV2, styled } from '@withjoy/joykit';
import React from 'react';
import { VIPData } from './VIPForm';

const StyledVIPImageContainer = styled(Box)`
  height: 250px;
  width: 250px;
  position: relative;
  border-radius: 8px;
  overflow: hidden;
  cursor: pointer;
  outline: none;
  &:focus {
    box-shadow: 0 0 0 2px var(--primary6, #2563eb);
  }
`;

const StyledVIPImageOverlay = styled(Flex)`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  align-items: center;
  justify-content: center;
  background: rgba(0, 0, 0, 0.32);
  opacity: 0;
  transition: opacity 0.2s;
  z-index: 2;
  pointer-events: none;

  ${StyledVIPImageContainer}:hover &,
  ${StyledVIPImageContainer}:focus & {
    opacity: 1;
    pointer-events: auto;
  }
`;

const StyledNoPhoto = styled(Flex)`
  justify-content: center;
  align-items: center;
  height: 100%;
  width: 100%;
  background: linear-gradient(135deg, #f3f4f6 0%, #e5e7eb 100%);
  border-radius: 8px;
  border: 1px dashed #d1d5db;
  color: var(--mono11);
  user-select: none;
  flex-direction: column;
  gap: 0.5rem;
`;

type VIPImageProps = {
  data: VIPData;
  onClick: () => void;
};

export const VIPImage = ({ data, onClick }: VIPImageProps) => {
  const { tq } = useTranslation('VIPForm');
  return (
    <StyledVIPImageContainer
      tabIndex={0}
      role="button"
      aria-label={tq`Pick Photo`}
      onClick={onClick}
    >
      {data.photoUrl ? (
        <img
          src={data.photoUrl}
          alt={data.title}
          style={{
            height: '100%',
            width: '100%',
            objectFit: 'cover',
            background: '#f5f5f5',
            display: 'block',
          }}
        />
      ) : (
        <StyledNoPhoto>
          <TextV2
            typographyVariant="body2"
            color="mono11"
          >
            {tq`No Photo`}
          </TextV2>
        </StyledNoPhoto>
      )}
      <StyledVIPImageOverlay>
        <TextV2
          typographyVariant="body2"
          color="white"
          fontWeight={600}
          background="rgba(0,0,0,0.4)"
          borderRadius={6}
          padding="0.25em 0.75em"
          pointerEvents="auto"
        >
          {tq`Click to choose`}
        </TextV2>
      </StyledVIPImageOverlay>
    </StyledVIPImageContainer>
  );
};
